import { quoteContactToContactOption } from 'Cube/communication/external/quotes.api.v1/adapters/quote.adapters.out'
import { useCubeContext } from 'modules/Cube/communication/internal/cube.domain.context'
import { useMemo } from 'react'

type UsePopoverRecipients = () => {
  contacts: { name: string; email: string }[]
  isVisible: boolean
}

export const usePopoverRecipients: UsePopoverRecipients = () => {
  const ctx = useCubeContext()

  const contacts = useMemo(() => {
    const quoteContacts = ctx.queries.rawData.data.quote.contacts

    return quoteContacts.map(contact => quoteContactToContactOption(contact))
  }, [ctx.queries.rawData.data.quote.contacts])

  const isVisible = contacts.length > 0

  return {
    contacts,
    isVisible
  }
}
